import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaTruck, FaIdCard, FaLeaf, FaBullseye, FaEye, FaHeart } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import "./AboutSection.css";

const AboutUs = () => {
  const { t } = useTranslation();

  const services = [
    {
      icon: <FaTruck size={30} color="#4e7662" />,
      title: t('about.service_fast_delivery'),
      subtitle: t('about.service_all_morocco'),
    },
    {
      icon: <FaIdCard size={30} color="#4e7662" />,
      title: t('about.service_licensed_products'),
      subtitle: t('about.service_licenses'),
    },
    {
      icon: <FaLeaf size={30} color="#4e7662" />,
      title: t('about.service_exceptional_ingredients'),
      subtitle: t('about.service_rare_pure_effective'),
    },
    {
      icon: <FaHeart size={30} color="#4e7662" />,
      title: t('about.service_proven_satisfaction'),
      subtitle: t('about.service_satisfaction_trust'),
    },
  ];

  return (
    <Container className="py-5">
      <p
        className="text-center fw-bold mb-3"
        style={{ color: '#4e7662', fontSize: '40px', fontFamily: 'Urbanist' }}
      >
        {t('about.text_about_us')}
      </p>
      <p className="text-center fst-italic text-muted mb-5"
        style={{ fontSize: '15px', fontFamily: 'Urbanist', color: '#7E7E7E' }}>
        {t('about.paragraphe_about_us1')}
      </p>
      <p className="text-center fst-italic text-muted mb-5"
        style={{ fontSize: '15px', fontFamily: 'Urbanist', color: '#7E7E7E' }}>
        {t('about.paragraphe_about_us2')}
      </p>
      <p className="text-center fst-italic text-muted mb-5"
        style={{ fontSize: '15px', fontFamily: 'Urbanist', color: '#7E7E7E' }}>
        {t('about.paragraphe_about_us3')}
      </p>

{/* <Row>
        {services.map((service, index) => (
          <Col md={6} lg={3} className="mb-4" key={index}>
            <Card
              className="h-100 text-white text-center p-4 shadow-sm rounded-4"
              style={{ backgroundColor: '#707070' }}
            >
              <Card.Body>
                <div className="d-flex justify-content-center mb-3">
                  {service.icon}
                </div>
                <Card.Title className="fw-bold">{service.title}</Card.Title>
                <Card.Text>{service.subtitle}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>       */}

      <section className="about-section" style={{ marginTop: '-70px' }}>
        <div className="about-container">
          {/* Mission */}
          <div className="about-box">
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <FaBullseye className="about-icon" size={28} style={{ fontWeight: 300 }} />
            </div>
            <h3 className="about-title">{t('about.mission_title')}</h3>
            <p className="about-quote">
              {t('about.mission_quote')}
            </p>
            <p className="about-text">
              {t('about.mission_text')}
            </p>
          </div>

          {/* Vision */}
          <div className="about-box">
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <FaEye className="about-icon" size={28} style={{ fontWeight: 300 }} />
            </div>
            <h3 className="about-title">{t('about.vision_title')}</h3>
            <p className="about-quote">
              {t('about.vision_quote')}
            </p>
            <p className="about-text">
              {t('about.vision_text')}
            </p>
          </div>

          {/* Valeurs */}
          <div className="about-box">
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <FaHeart className="about-icon" size={28} style={{ fontWeight: 300 }} />
            </div>
            <h3 className="about-title">{t('about.values_title')}</h3>
            <div className="about-values">
              <p><strong>{t('about.value_trust')}</strong><br />
                {t('about.value_trust_text')}
              </p>
              <p><strong>{t('about.value_adaptability')}</strong><br />
                {t('about.value_adaptability_text')}
              </p>
              <p><strong>{t('about.value_innovation')}</strong><br />
                {t('about.value_innovation_text')}
              </p>
              <p><strong>{t('about.value_accessibility')}</strong><br />
                {t('about.value_accessibility_text')}
              </p>
            </div>
          </div>
        </div>
      </section>
    </Container>
  );
};

export default AboutUs;
